import { Record, Map } from 'immutable';
import { LOCATION_CHANGE, SAVE_LOCATION_DATA } from 'domain/router/redux/reduxActions';

import { parseQuery } from './helpers';
import * as actions from './RouterActions';
import * as envActions from 'domain/env/envActions';

const LocationFactory = new Record({
  pathname: '',
  search: '',
  hash: '',
  key: '',
  state: new Map(),
  query: new Map(),
});

const RouterFactory = new Record({
  location: LocationFactory(),
  prevLocation: LocationFactory(),
  // This must be null by default. When accessing link directly (in a new tab with no history) router will pass empty string
  // and in case default value being empty string App component will not recognize complete pros change and will not force rerender
  // while when navigating through app routes will cause props to always change. This leads to inconsistency between direct link
  // and navigationg through app behaviours, making direct link scenarion have less rerenders.
  complete: null,
  customSingOut: false,
});

const createQueryAdapter = () => {
  let lastSearch = '';
  let lastResult = {};

  return (search) => {
    lastResult = lastSearch === search ? lastResult : parseQuery(search);
    lastSearch = search;
    return lastResult;
  };
};

const queryAdapter = createQueryAdapter();

export const reducer = {
  routing(state = RouterFactory(), action) {
    switch (action.type) {
      case LOCATION_CHANGE: {
        const {
          payload: { location },
        } = action;

        return state
          .set(
            'location',
            LocationFactory({
              ...location,
              query: queryAdapter(location.search),
              state: Map({ ...location.state }),
            }),
          )
          .set('prevLocation', state.location);
      }
      case SAVE_LOCATION_DATA: {
        const data = action.payload;

        return state.setIn(['location', 'state'], Map({ ...state.location.state.toJS(), ...data }));
      }
      case actions.completeEmptyAction.type:
      case actions.completeResetAction.type:
      case actions.completeAction.type:
        return state.set('complete', action.payload);

      case envActions.signOutAction.type:
        return state.set('customSingOut', !!action.payload);
      default:
        return state;
    }
  },
};
